(() => {
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  document.querySelectorAll('[data-kt-bug-report]').forEach((form) => {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const page = form.elements.page;
    const encoder = new TextEncoder();
    const label = button.textContent;
    let challenge = null;
    let challengeStarted = 0;
    let submitting = false;
    let initialPreparation;

    const incoming = new URLSearchParams(location.search).get('seite');
    const source = incoming || document.referrer;
    if (source) {
      try {
        const url = new URL(source, location.origin);
        if (url.origin === location.origin && !url.pathname.endsWith('/fehler-gefunden')) {
          // Do not copy query parameters, which may contain personal information or tokens.
          page.value = url.origin + url.pathname;
        }
      } catch (_) { /* The customer can enter the affected page manually. */ }
    }

    async function request(payload) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 25000);
      try {
        const response = await fetch(form.dataset.endpoint, {
          method: 'POST', credentials: 'omit', signal: controller.signal,
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!response.ok || !data.ok) throw Object.assign(new Error(data.error || 'request_failed'), { code: data.error });
        return data;
      } finally { clearTimeout(timer); }
    }

    async function prepare() {
      challenge = await request({ action: 'challenge' });
      challengeStarted = Date.now();
    }

    async function solve(token, difficulty) {
      if (!crypto.subtle || difficulty !== 3) throw new Error('verification_unavailable');
      for (let proof = 0; proof < 1000000; proof++) {
        const bytes = new Uint8Array(await crypto.subtle.digest('SHA-256', encoder.encode(`${token}:${proof}`)));
        if (bytes[0] === 0 && (bytes[1] & 0xf0) === 0) return String(proof);
        if (proof % 128 === 0) await delay(0);
      }
      throw new Error('verification_failed');
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting || !form.reportValidity()) return;
      submitting = true;
      button.disabled = true;
      button.textContent = form.dataset.sending;
      status.textContent = '';
      status.dataset.error = 'false';
      try {
        await initialPreparation;
        if (!challenge || Date.now() - challengeStarted > 25 * 60 * 1000) await prepare();
        const proof = await solve(challenge.token, challenge.difficulty);
        await delay(Math.max(0, 2200 - (Date.now() - challengeStarted)));
        await request({
          action: 'submit', token: challenge.token, proof,
          email: form.elements.email.value.trim(), page: page.value.trim(),
          message: form.elements.message.value.trim(), website: form.elements.website.value,
        });
        const previousPage = page.value;
        form.reset();
        page.value = previousPage;
        challenge = null;
        status.textContent = form.dataset.success;
      } catch (error) {
        status.dataset.error = 'true';
        status.textContent = error.code === 'rate_limited' ? form.dataset.limited
          : ['expired_challenge', 'invalid_challenge', 'used_challenge'].includes(error.code) ? form.dataset.challengeError
          : form.dataset.error;
        // Retain the token after transport errors: retrying it cannot send the same mail twice.
        if (error.code) challenge = null;
      } finally {
        submitting = false;
        button.disabled = false;
        button.textContent = label;
        status.focus();
      }
    });
    button.disabled = false;
    initialPreparation = prepare().catch(() => { challenge = null; });
  });
})();
